// extracted by mini-css-extract-plugin
export var footer = "_p5-0";
export var inherit = "_p5-1";
export var input = "_p5-2";
export var modalContent = "_p5-3";
export var quillEditor = "_p5-4";
export var subtitle = "_p5-5";